const zh_MO = {

            'title':"學歷認證系統",
            'preMessage':"歡迎使用澳門理工大學學歷認證系統！請按證明書/畢業證書所載資料輸入相關內容以進行認證。如有特別情況，歡迎透過電郵與本校招生註冊處聯繫（電郵：registry@mpu.edu.mo；電話：+853-8599 6111/6103）。",
            'form.studName' :"學生姓名",
            'form.dob' :"出生日期 (YYYY/MM/DD)",
            'form.studName.placeholder' :"請輸入姓名，你可輸入中文或外文姓名",
            'form.studName.hints' :"",
            'form.dob.placeholder' :"YYYY/MM/DD",
            'form.status':"文件類別",
            'form.status.current':"證明書",
            'form.status.graduate':"畢業證書",
            'form.gradYear':"畢業年份 (YYYY)",
            'form.gradYear.placeholder':"YYYY",
            'form.qual':"學歴",
            'form.qual.a':"A",
            'form.qual.b':"B",
            'form.qual.c':"C",
            'form.prog':"修讀之課程",
            'form.certNo':"證明書/畢業證書編號",
            'form.submit':"認證",
            'form.modify':"修改",
            'form.reset':"重新認證",
            'form.hints':"*必須填寫所有欄位",
            'result.title':"結果",
		'result.success':"茲確認　閣下所輸入的資料與系統中的記錄一致無誤。",
            'result.fail':"茲確認　閣下所輸入的資料與系統中的記錄不一致。請重新輸入或與招生註冊處聯繫。",
            'server.error':"系統錯誤，請重新整理網頁。",
            'form.error.required':"請輸入這個欄位",
            'form.error.isDate':"請輸入正確日期格式",
            'form.error.radio.required':"請選擇一個",
        }
export default zh_MO;


// WEBPACK FOOTER //
// ./src/i18n/zh_MO.js